import { connect } from 'react-redux';
import Footer from  './Footer';

//Binding the value of currentLanguage (to get it)
const mapStateToProps = (state) => {
    return {
		  language: state.currentLanguage, // Gets the current language (es, en, sv)
    }
}

export default connect(mapStateToProps, null)(Footer);


// WEBPACK FOOTER //
// ./src/redux/components/organisms/Footer/index.js